import AvailabilitiesGreenBar from './AvailabilitiesGreenBar';

export default AvailabilitiesGreenBar;
